import axios from "axios";
import jwt_decode from "jwt-decode";
import { userLogout } from "../features/customer";
import { toast } from "react-toastify";

// PRODUCTION
const LIVE_PRODUCTION_URL = "https://netfeebd.net/api/v1/";

//===> DEVELOPMENT URL
const SEYAM_DEV_URL = "http://localhost:9099/api/v1/";

//=================|| SELECT DEVELOPMENT URL ||=================//
const DEV_URL = LIVE_PRODUCTION_URL;
// const DEV_URL = SEYAM_DEV_URL;

//=================|| EXPORTING BASE URL ||=================//
export const baseURL =
  process.env.NODE_ENV == "development" ? DEV_URL : LIVE_PRODUCTION_URL;

export const publicRequest = axios.create({
  baseURL: baseURL,
});

const apiLink = axios.create({
  baseURL: baseURL,
});

apiLink.interceptors.request.use(
  async (config) => {
    const TOKEN = await JSON.parse(localStorage.getItem("netFeeToken"));

    if (!TOKEN) {
      userLogout();
      localStorage.removeItem("netFeeToken");
    }

    let currentDate = new Date();
    const decodedToken = jwt_decode(TOKEN);

    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      userLogout();
    } else {
      config.headers["authorization"] = "Bearer " + TOKEN;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// apiLink.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       toast.error(error.response?.data?.message);
//       setTimeout(() => {
//         userLogout();
//       }, 500);
//     }

//     return Promise.reject((error.response && error.response?.data) || error);
//   }
// );

export default apiLink;
